import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import axios from 'src/utils/axios'
import appointmentApi from '../api/appointment'
import productApi from 'src/api/product'
import format from 'date-fns/format'
import { isConstructorDeclaration } from 'typescript'

export const fetchAppointmentByDate = createAsyncThunk(
  'appointment/fetchAppointmentByDateStatus',
  async (date) => {
    let inputDate = date.split(';')
    let tab = inputDate[1]
    let view = inputDate[2] || 'resourceTimeGridDay' // 默认为resource视图
    
    // 根据视图类型计算endTime
    let endTime = null
    const currentDate = new Date(inputDate[0].replace(/\//g, '-'))
    
    if (view === 'timeGridWeek') {
      // Beautician视图：显示1周数据
      const endDate = new Date(currentDate)
      endDate.setDate(endDate.getDate() + 6) // 加6天得到一周的结束日期
      endTime = endDate.getFullYear() +
        '/' +
        (endDate.getMonth() + 1 < 10
          ? '0' + (endDate.getMonth() + 1)
          : endDate.getMonth() + 1 + '') +
        '/' +
        (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate() + '')
    } else if (view === 'dayGridMonth') {
      // Month视图：显示1个月数据
      const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0) // 获取当月最后一天
      endTime = endDate.getFullYear() +
        '/' +
        (endDate.getMonth() + 1 < 10
          ? '0' + (endDate.getMonth() + 1)
          : endDate.getMonth() + 1 + '') +
        '/' +
        (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate() + '')
    }
    
    // console.log("inputDate: ",inputDate[0], "endTime:", endTime)
    const response = await appointmentApi.getAppointment(inputDate[0], endTime)
    response['tab'] = tab
    response['view'] = view
    // console.log("response: ",response)
    return response
  }
)

const initialState = {
  events: [],
  // roomEvents: [],
  isModalOpen: false,
  selectedEventId: null,
  selectedRange: null,
  currentEvent: null,
  isModify: 0,
  addEventId: null,
  loading: true,
  error: '',
  status: '',
}

const slice = createSlice({
  name: 'appointment',
  initialState,
  reducers: {
    /* Room */

    //Deprecated
    getEvents(state, action) {
      const events = action.payload
      const roomEvents = events
      for (let i = 0; i < events.length; i++) {
        if (events[i].status == 0) {
          events[i].color = '#00000061'
          events[i].backgroundColor = '#C7C9C7'
          events[i].borderColor = '#00000000'
        } else if (events[i].status == 1) {
          events[i].color = '#000000DE'
          events[i].backgroundColor = '#B3DCFA'
          events[i].borderColor = '#00000000'
        } else if (events[i].status == 2) {
          events[i].color = '#000000DE'
          events[i].backgroundColor = '#FFECAE'
          events[i].borderColor = '#00000000'
        } else if (events[i].status == 3) {
          events[i].color = '#FFFFFF'
          events[i].backgroundColor = '#81F1AD'
          events[i].borderColor = '#00000000'
        } else if (events[i].status == 4) {
          events[i].color = '#FFFFFF'
          events[i].backgroundColor = '#F2ABB5'
          events[i].borderColor = '#00000000'
        }
        events[i].title =
          events[i].firstName +
          ' ' +
          events[i].lastName +
          ' ' +
          [...events[i].products].map((ele) => {
            if (ele != null) {
              return ele.name + ' '
            } else {
              return ' '
            }
          })
        events[i].start = events[i].start.replace(/\//g, '-')
        events[i].end = events[i].endd.replace(/\//g, '-')
        events[i].endd = events[i].endd.replace(/\//g, '-')
        events[i].resourceIds = []
        events[i].resourceIds.push(events[i].employeeId)
      }
      state.events = events

      /* roomEvent */
      // for (let i = 0; i < roomEvents.length; i++) {
      //   if (roomEvents[i].status == 0) {
      //     roomEvents[i].color = '#00000061'
      //     roomEvents[i].backgroundColor = '#C7C9C7'
      //     roomEvents[i].borderColor = '#00000000'
      //   } else if (roomEvents[i].status == 1) {
      //     roomEvents[i].color = '#000000DE'
      //     roomEvents[i].backgroundColor = '#B3DCFA'
      //     roomEvents[i].borderColor = '#00000000'
      //   } else if (roomEvents[i].status == 2) {
      //     roomEvents[i].color = '#000000DE'
      //     roomEvents[i].backgroundColor = '#FFECAE'
      //     roomEvents[i].borderColor = '#00000000'
      //   } else if (roomEvents[i].status == 3) {
      //     roomEvents[i].color = '#FFFFFF'
      //     roomEvents[i].backgroundColor = '#81F1AD'
      //     roomEvents[i].borderColor = '#00000000'
      //   } else if (roomEvents[i].status == 4) {
      //     roomEvents[i].color = '#FFFFFF'
      //     roomEvents[i].backgroundColor = '#F2ABB5'
      //     roomEvents[i].borderColor = '#00000000'
      //   }
      //   roomEvents[i].title =
      //     roomEvents[i].firstName +
      //     ' ' +
      //     roomEvents[i].lastName +
      //     ' ' +
      //     [...roomEvents[i].products].map((ele) => {
      //       if (ele != null) {
      //         return ele.name + ' '
      //       } else {
      //         return ' '
      //       }
      //     })
      //   roomEvents[i].start = roomEvents[i].start.replace(/\//g, '-')
      //   roomEvents[i].end = roomEvents[i].endd.replace(/\//g, '-')
      //   roomEvents[i].endd = roomEvents[i].endd.replace(/\//g, '-')
      //   roomEvents[i].resourceIds = []
      //   if (roomEvents[i].room) {
      //     roomEvents[i].resourceIds.push(roomEvents[i].room.id)
      //   }
      // }
      // state.roomEvents = roomEvents
    },
    getEmployeeAppointment(state, action) {
      const events = action.payload
      const roomEvents = events
      for (let i = 0; i < events.length; i++) {
        if (events[i].status == 0) {
          events[i].color = '#00000061'
          events[i].backgroundColor = '#C7C9C7'
          events[i].borderColor = '#00000000'
        } else if (events[i].status == 1) {
          events[i].color = '#000000DE'
          events[i].backgroundColor = '#B3DCFA'
          events[i].borderColor = '#00000000'
        } else if (events[i].status == 2) {
          events[i].color = '#000000DE'
          events[i].backgroundColor = '#FFECAE'
          events[i].borderColor = '#00000000'
        } else if (events[i].status == 3) {
          events[i].color = '#FFFFFF'
          events[i].backgroundColor = '#81F1AD'
          events[i].borderColor = '#00000000'
        } else if (events[i].status == 4) {
          events[i].color = '#FFFFFF'
          events[i].backgroundColor = '#F2ABB5'
          events[i].borderColor = '#00000000'
        }
        events[i].title =
          events[i].firstName +
          ' ' +
          events[i].lastName +
          ' ' +
          [...events[i].products].map((ele) => {
            if (ele != null) {
              return ele.name + ' '
            } else {
              return ' '
            }
          })
        events[i].start = events[i].start.replace(/\//g, '-')
        events[i].end = events[i].endd.replace(/\//g, '-')
        events[i].endd = events[i].endd.replace(/\//g, '-')
        events[i].resourceIds = []
        events[i].resourceIds.push(events[i].employeeId)
      }
      state.events = events
    },
    createEvent(state, action) {
      const events = action.payload
      const roomEvents = events
      // for (let i = 0; i < events.length; i++) {
      //   events[i].title =
      //     events[i].firstName +
      //     ' ' +
      //     events[i].lastName +
      //     ' ' +
      //     [...events[i].products].map((ele) => {
      //       // console.log('ele', ele)
      //       if (ele != null) {
      //         return ele.name + ' '
      //       } else {
      //         return ' '
      //       }
      //     })
      //   events[i].start = events[i].start.replace(/\//g, '-')
      //   events[i].end = events[i].endd.replace(/\//g, '-')
      //   events[i].endd = events[i].endd.replace(/\//g, '-')
      //   events[i].resourceIds = []
      //   events[i].resourceIds.push(events[i].employeeId)
      //   if (events[i].status == 0) {
      //     events[i].color = '#00000061'
      //     events[i].backgroundColor = '#C7C9C7'
      //     events[i].borderColor = '#00000000'
      //   } else if (events[i].status == 1) {
      //     events[i].color = '#000000DE'
      //     events[i].backgroundColor = '#B3DCFA'
      //     events[i].borderColor = '#00000000'
      //   } else if (events[i].status == 2) {
      //     events[i].color = '#000000DE'
      //     events[i].backgroundColor = '#FFECAE'
      //     events[i].borderColor = '#00000000'
      //   } else if (events[i].status == 3) {
      //     events[i].color = '#FFFFFF'
      //     events[i].backgroundColor = '#81F1AD'
      //     events[i].borderColor = '#00000000'
      //   } else if (events[i].status == 4) {
      //     events[i].color = '#FFFFFF'
      //     events[i].backgroundColor = '#F2ABB5'
      //     events[i].borderColor = '#00000000'
      //   }
      // }

      // // if(state.isModify == 0){
      // state.events = events
      // }
      // console.log(state.events)
    },
    selectEvent(state, action) {
      const { eventId = null } = action.payload.data.id

      state.isModalOpen = true
      state.selectedEventId = eventId
      state.currentEvent = action.payload.data
      // console.log(state.currentEvent);
      state.isModify = 1
    },
    updateEvent(state, action) {
      const event = action.payload

      state.events = _.map(state.events, (_event) => {
        if (_event.id === event.id) {
          return event
        }

        return _event
      })
    },
    deleteEvent(state, action) {
      const { eventId } = action.payload

      state.events = _.reject(state.events, { id: eventId })
    },
    cancelEvent(state, action) {
      const { eventId } = action.payload

      state.events = _.reject(state.events, { id: eventId })
    },
    selectRange(state, action) {
      const { start, end, id } = action.payload
      state.isModify = 0
      state.currentEvent = null
      state.isModalOpen = true
      if (id != -1) {
        state.addEventId = id
      }
      state.selectedRange = {
        start,
        end,
      }
    },
    openModal(state) {
      state.isModalOpen = true
    },
    closeModal(state) {
      state.isModalOpen = false
      state.selectedEventId = null
      state.selectedRange = null
    },
    changeCurrentEvent(state) {
      state.currentEvent = null
    },
    changeModifyStatus(state) {
      state.isModify = 0
    },
  },
  extraReducers: {
    [fetchAppointmentByDate.pending]: (state, action) => {
      state.status = 'loading'
      state.loading = true
    },
    [fetchAppointmentByDate.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      const events = action.payload.data
      const tab = action.payload.tab
      const view = action.payload.view
      for (let i = 0; i < events.length; i++) {
        if (events[i].status == 0) {
          events[i].textColor = 'textPrimary'
          events[i].backgroundColor = '#C7C9C7'
          events[i].borderColor = '#A0A3A0'
        } else if (events[i].status == 1) {
          events[i].textColor = 'textPrimary'
          events[i].backgroundColor = '#B3DCFA'
          events[i].borderColor = '#6BBBF5'
        } else if (events[i].status == 2) {
          events[i].textColor = 'textPrimary'
          events[i].backgroundColor = '#FFECAE'
          events[i].borderColor = '#FFDA62'
        } else if (events[i].status == 3) {
          events[i].textColor = 'textPrimary'
          events[i].backgroundColor = '#AFF6C4'
          events[i].borderColor = '#6AEE91'
        } else if (events[i].status == 4) {
          events[i].textColor = 'textPrimary'
          events[i].backgroundColor = '#F2ABB5'
          events[i].borderColor = '#E8697B'
        }
        events[i].start = events[i].start.replace(/\//g, '-')
        events[i].end = events[i].endd.replace(/\//g, '-')
        events[i].endd = events[i].endd.replace(/\//g, '-')
        
        // 只有resource-based视图才需要resourceIds
        if (view === 'resourceTimeGridDay') {
          events[i].resourceIds = []
          if (tab === 'appointment') {
            events[i].resourceIds.push(events[i].employeeId)
          } else if (tab === 'room') {
            events[i].resourceIds.push(events[i].room?.id || events[i].roomId)
          }
        } else {
          // timeGridWeek和dayGridMonth视图不需要resourceIds
          delete events[i].resourceIds
        }
        
        if (tab === 'appointment') {
          events[i].title =
            events[i].firstName +
            ' ' +
            events[i].lastName +
            ' ' +
            [...events[i].products].map((ele) => {
              // console.log('ele', ele)
              if (ele != null) {
                return ele.name + ' '
              } else {
                return ' '
              }
            })
          if (events[i].room) {
            events[i].title =
              events[i].room.name +
              ' ' +
              (events[i].customer == null ? '' : events[i].customer.refId + ' ')  +
              events[i].firstName +
              ' ' +
              events[i].lastName +
              ' ' +
              [...events[i].products].map((ele) => {
                // console.log('ele', ele)
                if (ele != null) {
                  return ele.name + ' '
                } else {
                  return ' '
                }
              })
          }
          if (events[i].description) {
            events[i].borderColor='#E1594A'
            events[i].color='#8BC34A'
            let des=events[i].description.split('\n')
            for(let s=0;s<des.length;s++)
            {
              events[i].title += ' '+des[s]
            } 
          }
        } else if (tab === 'room') {
          if (events[i].room) {
            events[i].resourceIds.push(events[i].room.id)
            events[i].title =
              events[i].employee.firstName +
              ' ' +
              events[i].firstName +
              ' ' +
              events[i].lastName +
              ' ' +
              [...events[i].products].map((ele) => {
                // console.log('ele', ele)
                if (ele != null) {
                  return ele.name + ' '
                } else {
                  return ' '
                }
              })
          }
        }
        // 保留storeNames信息用于过滤
        if (events[i].storeNames) {
          events[i].storeNames = events[i].storeNames;
        }
      }
      state.events = events
      state.loading = false
    },
    [fetchAppointmentByDate.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  },
})

export const reducer = slice.reducer

export const changeCurrentEvent = () => (dispatch) => {
  dispatch(slice.actions.changeCurrentEvent())
}

export const renderEvent = (data) => async (dispatch) => {
  dispatch(slice.actions.getEvents(data))
}

export const changeModifyStatus = () => (dispatch) => {
  dispatch(slice.actions.changeModifyStatus())
}

//Deprecated
export const getEvents = (date, data) => async (dispatch) => {
  // const response = await axios.get('/api/appointment/events');

  let response = data
  // out of scopes of 3 months
  if (data == null) {
    // console.log(1)

    response = await appointmentApi.getAppointment(date)
    // within scope
  } else {
    // console.log(2)
    response = data
  }

  // let arr = [];
  // console.log(response)
  // for(let j = 0; j < response.data.length; j++){
  //   let str = "";
  //   for(let i = 0; i < response.data[j].products.length; i ++){
  //     let obj = await productApi.findProductById(parseInt(response.data[j].products[i]));
  //       if(i == response.data[j].products.length-1){
  //         str += obj.name;
  //       }else{
  //         str +=obj.name+",";
  //       }
  //   }
  //   arr.push(str);
  // }
  dispatch(slice.actions.getEvents(response.data))
}
export const getEmployeeAppointment = (data) => async (dispatch) => {
  const response = await appointmentApi.getAppointmentByEmployee(data)
  // let arr = [];
  // console.log(response)
  // for(let i = 0; i < response.length; i ++){
  //   for(let j = 0; j < response[i].products.length; j++){
  //     let obj = await productApi.findProductById(parseInt(response[i].products[j]));
  //     arr.push(obj.name);
  //   }
  // }
  dispatch(slice.actions.getEmployeeAppointment(response))
}

export const createEvent = (data, employeeId) => async (dispatch) => {
  // const response = await axios.post('/api/appointment/events/new', data);
  const response = await appointmentApi.createAppointment(data, employeeId)
  // let arr = [];
  // for(let i = 0; i < response.data.products.length; i ++){
  //   let obj = await productApi.findProductById(parseInt(response.data.products[i]));
  //   arr.push(obj.name);
  // }
  dispatch(slice.actions.createEvent(+response))
}

export const selectEvent = (eventId) => async (dispatch) => {
  const response = await appointmentApi.findAppointmentById(eventId)
  // console.log(response)
  // console.log('select Event : ', response)
  dispatch(slice.actions.selectEvent(response))
}

export const updateEvent = (eventId) => async (dispatch) => {
  // const response = await axios.post('/api/appointment/events/update', {
  //   eventId,
  //   update
  // });
  const response = await appointmentApi.findAppointmentById(eventId)
  // console.log('update Event : ', response)
  dispatch(slice.actions.updateEvent(response))
}

export const deleteEvent = (eventId) => async (dispatch) => {
  // console.log(eventId)
  // await axios.post('/api/appointment/events/remove', {
  //   eventId
  // });

  let response = await appointmentApi.deleteAppointment(eventId)

  dispatch(slice.actions.deleteEvent({ eventId }))
}

export const cancelEvent = (eventId) => async (dispatch) => {
  let response = await appointmentApi.cancelAppointment(eventId)
  // console.log('response', response)
  dispatch(slice.actions.cancelEvent({ eventId }))
  return response.success
}

// select event from calendar with eployee id
export const selectRange = (start, end, id) => (dispatch) => {
  dispatch(
    slice.actions.selectRange({
      start: start,
      end: end,
      id: id,
    })
  )
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export default slice
